/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeedbackItemResVo } from './FeedbackItemResVo';
import {
    FeedbackItemResVoFromJSON,
    FeedbackItemResVoFromJSONTyped,
    FeedbackItemResVoToJSON,
    FeedbackItemResVoToJSONTyped,
} from './FeedbackItemResVo';

/**
 * 
 * @export
 * @interface ResponseFeedbackItemResVo
 */
export interface ResponseFeedbackItemResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseFeedbackItemResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseFeedbackItemResVo
     */
    message?: string;
    /**
     * 
     * @type {FeedbackItemResVo}
     * @memberof ResponseFeedbackItemResVo
     */
    data?: FeedbackItemResVo;
}

/**
 * Check if a given object implements the ResponseFeedbackItemResVo interface.
 */
export function instanceOfResponseFeedbackItemResVo(value: object): value is ResponseFeedbackItemResVo {
    return true;
}

export function ResponseFeedbackItemResVoFromJSON(json: any): ResponseFeedbackItemResVo {
    return ResponseFeedbackItemResVoFromJSONTyped(json, false);
}

export function ResponseFeedbackItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseFeedbackItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : FeedbackItemResVoFromJSON(json['data']),
    };
}

export function ResponseFeedbackItemResVoToJSON(json: any): ResponseFeedbackItemResVo {
    return ResponseFeedbackItemResVoToJSONTyped(json, false);
}

export function ResponseFeedbackItemResVoToJSONTyped(value?: ResponseFeedbackItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': FeedbackItemResVoToJSON(value['data']),
    };
}

